var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Warning = function () {
  EHDI.aka.Container.call(this);
};

EHDI.game.Warning.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Warning.prototype.init = function (spawnX, spawnY) {
  this._warningTexture;
  this._warningSprite;
  this._timelineMax;
  this._tl;
  this._holeNumber;
  this.spawnX = spawnX;
  this.spawnY = spawnY;

  if (this._warningTexture == null) {
    this._warningTexture = EHDI.Assets.images['fx_warning'];
  }

  if (this._warningSprite == null) {
    this._warningSprite = new EHDI.aka.Sprite(this._warningTexture);
    this._warningSprite.anchor.x = 0.5;
    this._warningSprite.anchor.y = 0.5;

    this.addChild(this._warningSprite);
  }

  this.scale.x = 0.5;
  this.scale.y = 0.5;

  this.x = this.spawnX + 50;
  this.y = this.spawnY + 50;

  if (this._timelineMax == null) {
    this._timelineMax = new TimelineMax({repeat:-1, yoyo:true});
  }

  this._tl = this._timelineMax.to(this.scale, 0.2, {x:1, y:1, ease:Power0.easeNone});
};

EHDI.game.Warning.prototype.reset = function () {
  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  if (this._timelineMax != null) {
    this._timelineMax.kill();
    this._timelineMax = null;
  }
}
